import type React from 'react';
import { createContext, useContext, type PropsWithChildren } from 'react';
import { LanguageEnum, type User } from 'types/swagger';

interface UserSessionContextProps extends PropsWithChildren {
  timezone: string;
  setTimezone: (timezone: string) => void;
  locale: LanguageEnum;
  user: User | null;
  synclogWebsocket: WebSocket | null;
  notificationsWebsocket: WebSocket | null;
  startPage: string | null;
  isLoggingIn: boolean;
  callFetchUser: (access: string, refresh: string) => void;
  setLocale: (locale: LanguageEnum) => void;
  setStartPage: React.Dispatch<React.SetStateAction<string | null>>;
  shouldRedirect: boolean;
  setShouldRedirect: React.Dispatch<React.SetStateAction<boolean>>;
}

export const UserSessionContext = createContext<UserSessionContextProps>({
  timezone: '',
  setTimezone: () => null,
  locale: LanguageEnum.Es,
  user: null,
  synclogWebsocket: null,
  notificationsWebsocket: null,
  startPage: null,
  isLoggingIn: false,
  callFetchUser: () => null,
  setLocale: () => null,
  setStartPage: () => null,
  shouldRedirect: false,
  setShouldRedirect: () => null,
});

export const useSessionContext = () => {
  const context = useContext(UserSessionContext);
  return context;
};
